import { IState } from 'shared/store';

export function getTransportAccessibilityInfrastructure(state: IState) {
  return state.newbuildingInfrastructure.transportAccessibilityInfrastructure;
}
